module.exports = __webpack_public_path__ + "media/images/prizes__prizeFg--2-17a9f50ee34f57ad5c540bcd235a7170.png";